import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 0);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black bg-opacity-50' : 'bg-transparent'
      }`}
      style={{ paddingBottom: isScrolled ? '20px' : '0' }}
    >
      <nav className="relative pt-2">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/" className="block">
                <img
                  src="/Logo.png"
                  alt="HIK"
                  className="h-16 w-auto mt-4"
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
            <Link 
                to="/" 
                className="text-white mt-2 inline-block"
                style={{ 
                  fontFamily: 'Belleza, serif', 
                  fontWeight: 400, 
                  fontSize: '20px', 
                  lineHeight: '100%' 
                }}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className="text-white mt-2 inline-block"
                style={{ 
                  fontFamily: 'Belleza, serif', 
                  fontWeight: 400, 
                  fontSize: '20px', 
                  lineHeight: '100%' 
                }}
              >
                About
              </Link>
              <Link 
                to="/services" 
                className="text-white mt-2 inline-block"
                style={{ 
                  fontFamily: 'Belleza, serif', 
                  fontWeight: 400, 
                  fontSize: '20px', 
                  lineHeight: '100%' 
                }}
              >
                Services
              </Link>
              <Link 
                to="/products" 
                className="text-white mt-2 inline-block"
                style={{ 
                  fontFamily: 'Belleza, serif', 
                  fontWeight: 400, 
                  fontSize: '20px', 
                  lineHeight: '100%' 
                }}
              >
                Products
              </Link>
              <Link to="/get-in-touch">
                <button 
                  className="text-white px-4 py-1.5 rounded-md font-normal text-base hover:bg-opacity-90 transition-all mt-2"
                  style={{ 
                    fontFamily: 'Belleza, serif', 
                    lineHeight: '100%', 
                    backgroundColor: '#ACAD96',
                    fontSize: '20px',
                    position: 'relative',
                    // Only apply top offset on About and Services pages
                    top: (window.location.pathname === '/about' || window.location.pathname === '/services') ? '-4px' : undefined
                  }}
                >
                  Get in Touch
                </button>
              </Link>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-white hover:text-green-300 transition-colors"
                aria-label="Toggle menu"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Navigation - right slide-in drawer */}
          <div className="md:hidden">
            {/* Backdrop */}
            <div
              className={`fixed inset-0 z-40 transition-opacity duration-300 ${isMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
              style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
              onClick={() => setIsMenuOpen(false)}
            />
            {/* Drawer */}
            <div
              className={`fixed top-0 right-0 z-50 h-screen w-72 sm:w-80 transform transition-transform duration-300 ease-in-out ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
              style={{ backgroundColor: 'rgba(39, 37, 37, 0.95)' }}
              role="dialog"
              aria-modal="true"
            >
              <div className="px-4 py-4 border-b border-white/20 flex items-center justify-between">
                <span className="text-white" style={{ fontFamily: 'Belleza, serif' }}>Menu</span>
                <button
                  onClick={() => setIsMenuOpen(false)}
                  className="text-white hover:text-green-300 transition-colors"
                  aria-label="Close menu"
                >
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="px-4 pt-4 space-y-1">
              <Link 
                  to="/" 
                  className="block px-3 py-2 text-white hover:text-green-300 transition-colors duration-200"
                  style={{ 
                    fontFamily: 'Belleza, serif', 
                    fontWeight: 400, 
                    fontSize: '20px', 
                    lineHeight: '100%' 
                  }}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
                <Link 
                  to="/about" 
                  className="block px-3 py-2 text-white hover:text-green-300 transition-colors duration-200"
                  style={{ 
                    fontFamily: 'Belleza, serif', 
                    fontWeight: 400, 
                    fontSize: '20px', 
                    lineHeight: '100%' 
                  }}
                  onClick={() => setIsMenuOpen(false)}
                >
                  About
                </Link>
                <Link 
                  to="/services" 
                  className="block px-3 py-2 text-white hover:text-green-300 transition-colors duration-200"
                  style={{ 
                    fontFamily: 'Belleza, serif', 
                    fontWeight: 400, 
                    fontSize: '20px', 
                    lineHeight: '100%' 
                  }}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Services
                </Link>
                <Link 
                  to="/products" 
                  className="block px-3 py-2 text-white hover:text-green-300 transition-colors duration-200"
                  style={{ 
                    fontFamily: 'Belleza, serif', 
                    fontWeight: 400, 
                    fontSize: '20px', 
                    lineHeight: '100%' 
                  }}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Products
                </Link>
                <div className="px-3 py-2">
                <Link to="/get-in-touch" onClick={() => setIsMenuOpen(false)}>
                    <button 
                      className="text-gray-900 px-6 py-2 rounded-lg font-semibold hover:bg-opacity-90 transition-all duration-200 w-full"
                      style={{ 
                        fontFamily: 'Poppins, sans-serif', 
                        backgroundColor: '#ACAD96',
                        fontSize: '18px'
                      }}
                    >
                      Get in Touch
                    </button>
                  </Link>
                </div>
              </div>
              </div>
            </div>
          </div>
      </nav>
    </div>
  );
};

export default Navbar;